import type { RestorableRequestedMode } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

export const normalizeRestorableRequestedMode = (
	mode: unknown,
): RestorableRequestedMode | undefined => {
	if (mode === 'MAX' || mode === 'MARATHON' || mode === 'DEEP_RESEARCH') {
		return mode;
	}

	return undefined;
};
